import React, { useState } from "react";
import poleCenter from "../assets/pole-cente.png";
import "./AtmospoleFeatureShowcase.css";

const AtmospoleFeatureShowcase = () => {
  const [activeFeature, setActiveFeature] = useState(null);

  const features = [
    {
      id: "01",
      number: "01",
      title: "01 SOLAR POWERED",
      description:
        "Designed to harness solar energy for efficient outdoor operation.",
      side: "left",
      cardTop: 155,
      cardLeft: 35,
      cardDot: { x: 385, y: 180 },
      poleDot: { x: 592, y: 60 },
      mobilePos: { top: "10.5%", left: "50%" },
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="3.5" fill="#00e5ff" fillOpacity="0.2" />
          <line x1="12" y1="2" x2="12" y2="5" />
          <line x1="12" y1="19" x2="12" y2="22" />
          <line x1="4.22" y1="4.22" x2="6.34" y2="6.34" />
          <line x1="17.66" y1="17.66" x2="19.78" y2="19.78" />
          <line x1="2" y1="12" x2="5" y2="12" />
          <line x1="19" y1="12" x2="22" y2="12" />
          <line x1="4.22" y1="19.78" x2="6.34" y2="17.66" />
          <line x1="17.66" y1="6.34" x2="19.78" y2="4.22" />
        </svg>
      ),
    },
    {
      id: "02",
      number: "02",
      title: "02 WI-FI CONNECTED SMART NODE",
      description:
        "Connected for continuous communication and real-time environmental data transmission.",
      side: "left",
      cardTop: 355,
      cardLeft: 35,
      cardDot: { x: 385, y: 380 },
      poleDot: { x: 600, y: 148 },

      // cardDot: { x: 385, y: 180 },
      // poleDot: { x: 592, y: 60 },
      mobilePos: { top: "29.5%", left: "45%" },
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12.55a11 11 0 0 1 14.08 0" />
          <path d="M1.42 9a16 16 0 0 1 21.16 0" />
          <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
          <circle cx="12" cy="20" r="1.5" fill="#00e5ff" />
        </svg>
      ),
    },
    {
      id: "05",
      number: "05",
      title: "05 REAL-TIME ENVIRONMENTAL DISPLAY",
      description:
        "Makes local environmental conditions visible directly at the point of deployment.",
      side: "left",
      cardTop: 575,
      cardLeft: 35,

      //  cardDot: { x: 385, y: 380 },
      // poleDot: { x: 600, y: 148 },


      cardDot: { x: 385, y: 590 },
      poleDot: { x: 580, y: 502 },
      mobilePos: { top: "71.0%", left: "45%" },
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
    },
    {
      id: "03",
      number: "03",
      title: "03 INTEGRATED CCTV SURVEILLANCE",
      description:
        "Integrated surveillance capability built directly into the infrastructure.",
      side: "right",
      cardTop: 155,
      cardLeft: 815,
      cardDot: { x: 815, y: 170 },
      poleDot: { x: 600, y: 108 },
      // cardDot: { x: 385, y: 180 },
      // poleDot: { x: 592, y: 60 },
      mobilePos: { top: "17.5%", left: "54%" },
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M23 7l-7 5 7 5V7z" />
          <rect x="1" y="5" width="15" height="14" rx="2.5" ry="2.5" />
        </svg>
      ),
    },
    {
      id: "04",
      number: "04",
      title: "04 AIR PURIFICATION + CO2 & CH4 REDUCTION",
      description:
        "Integrated systems for air purification and CO2 and CH4 reduction.",
      side: "right",
      cardTop: 355,
      cardLeft: 815,
      cardDot: { x: 815, y: 370 },
      poleDot: { x: 686, y: 358 },
      mobilePos: { top: "50.5%", left: "58%" },
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M9.59 4.59A2 2 0 1 1 11 8H2" />
          <path d="M12.59 19.41A2 2 0 1 0 14 16H2" />
          <path d="M17.73 7.73A2.5 2.5 0 1 1 19.5 12H2" />
        </svg>
      ),
    },
    {
      id: "06",
      number: "06",
      title: "06 BUILT FOR EXTREME ENVIRONMENTS",
      description:
        "Engineered for reliable operation across demanding outdoor environmental conditions.",
      side: "right",
      cardTop: 575,
      cardLeft: 815,
      cardDot: { x: 815, y: 590 },
      poleDot: { x: 652, y: 572 },
      mobilePos: { top: "71.0%", left: "58%" },
      icon: (
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="atmospole-feature-showcase-section">
      {/* Background ambient lighting */}
      <div className="atmospole-ambient-glow" />

      <div className="atmospole-showcase-container">
        {/* ====================================================
            DESKTOP STAGE (Interactive HUD diagram)
            ==================================================== */}
        <div className="atmospole-stage-desktop">
          {/* Center AtmosPOLE Image */}
          <div className="atmospole-center-pole-wrap">
            <img
              src={poleCenter}
              alt="AtmosPOLE Smart System"
              className="atmospole-center-pole-img"
            />
          </div>

          {/* SVG Overlay for Dashed Lines & Anchor Dots */}
          <svg
            className="atmospole-svg-overlay"
            viewBox="0 0 1200 800"
            preserveAspectRatio="xMidYMid meet"
          >
            <defs>
              <filter id="cyanGlow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="3" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>

            {features.map((item) => {
              const isActive = activeFeature === item.id;
              const isDimmed = activeFeature !== null && !isActive;

              return (
                <g key={`svg-group-${item.id}`}>
                  {/* Connecting Dashed Line */}
                  <line
                    x1={item.cardDot.x}
                    y1={item.cardDot.y}
                    x2={item.poleDot.x}
                    y2={item.poleDot.y}
                    className={`atmospole-connector-line ${isActive ? "active" : ""
                      } ${isDimmed ? "dimmed" : ""}`}
                  />

                  {/* Card Anchor Dot */}
                  <circle
                    cx={item.cardDot.x}
                    cy={item.cardDot.y}
                    r={isActive ? 4.5 : 3.5}
                    className={`atmospole-svg-dot ${isActive ? "active" : ""}`}
                  />

                  {/* Pole Target Dot */}
                  <circle
                    cx={item.poleDot.x}
                    cy={item.poleDot.y}
                    r={isActive ? 5 : 4}
                    className={`atmospole-svg-dot ${isActive ? "active" : ""}`}
                  />
                </g>
              );
            })}
          </svg>

          {/* Hotspot Radar Pulse Targets on the Pole */}
          {features.map((item) => {
            const isActive = activeFeature === item.id;
            return (
              <button
                key={`hotspot-${item.id}`}
                className={`atmospole-hotspot-marker ${isActive ? "active" : ""
                  }`}
                style={{
                  left: `${(item.poleDot.x / 1200) * 100}%`,
                  top: `${(item.poleDot.y / 800) * 100}%`,
                }}
                onMouseEnter={() => setActiveFeature(item.id)}
                onMouseLeave={() => setActiveFeature(null)}
                onClick={() =>
                  setActiveFeature(activeFeature === item.id ? null : item.id)
                }
                aria-label={item.title}
              >
                <div className="atmospole-hotspot-pulse" />
                <div className="atmospole-hotspot-pulse-outer" />
                <div className="atmospole-hotspot-core" />
              </button>
            );
          })}

          {/* Feature Cards (3 Left, 3 Right) */}
          {features.map((item) => {
            const isActive = activeFeature === item.id;
            const isDimmed = activeFeature !== null && !isActive;

            return (
              <div
                key={`card-${item.id}`}
                className={`atmospole-card-desktop ${item.side === "right" ? "right-card" : "left-card"
                  } ${isActive ? "active" : ""} ${isDimmed ? "dimmed" : ""}`}
                style={{
                  top: `${item.cardTop}px`,
                  left: `${item.cardLeft}px`,
                }}
                onMouseEnter={() => setActiveFeature(item.id)}
                onMouseLeave={() => setActiveFeature(null)}
                onClick={() =>
                  setActiveFeature(activeFeature === item.id ? null : item.id)
                }
              >
                {item.side === "left" ? (
                  // Left Card Layout: [Icon] [Title •]
                  <>
                    <div className="atmospole-card-header-left">
                      <div className="atmospole-card-icon-wrap">
                        {item.icon}
                      </div>
                      <div className="atmospole-card-title-group">
                        <h4 className="atmospole-card-title">{item.title}</h4>
                      </div>
                    </div>
                    <p className="atmospole-card-desc">{item.description}</p>
                  </>
                ) : (
                  // Right Card Layout: [• Title] [Icon]
                  <>
                    <div className="atmospole-card-header-right">
                      <div className="atmospole-card-title-group">
                        <h4 className="atmospole-card-title">{item.title}</h4>
                      </div>
                      <div className="atmospole-card-icon-wrap">
                        {item.icon}
                      </div>
                    </div>
                    <p className="atmospole-card-desc">{item.description}</p>
                  </>
                )}
              </div>
            );
          })}
        </div>

        {/* ====================================================
            MOBILE & TABLET STAGE (<= 992px)
            ==================================================== */}
        <div className="atmospole-stage-mobile">
          {/* Mobile Center Pole with Interactive Badges */}
          <div className="atmospole-mobile-pole-box">
            <img
              src={poleCenter}
              alt="AtmosPOLE Smart System"
              className="atmospole-mobile-pole-img"
            />
            {features.map((item) => (
              <div
                key={`mob-hotspot-${item.id}`}
                className={`atmospole-mobile-hotspot ${activeFeature === item.id ? "active" : ""
                  }`}
                style={{
                  top: item.mobilePos.top,
                  left: item.mobilePos.left,
                }}
                onClick={() =>
                  setActiveFeature(activeFeature === item.id ? null : item.id)
                }
              >
                {item.number}
              </div>
            ))}
          </div>

          {/* Mobile Feature Cards Grid */}
          <div className="atmospole-mobile-cards-grid">
            {features.map((item) => {
              const isActive = activeFeature === item.id;
              return (
                <div
                  key={`mob-card-${item.id}`}
                  className={`atmospole-mobile-card ${isActive ? "active" : ""
                    }`}
                  onClick={() =>
                    setActiveFeature(activeFeature === item.id ? null : item.id)
                  }
                >
                  <div className="atmospole-mobile-card-top">
                    <div className="atmospole-card-icon-wrap">{item.icon}</div>
                    <h4 className="atmospole-mobile-card-title">
                      {item.title}
                    </h4>
                  </div>
                  <p className="atmospole-mobile-card-desc">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AtmospoleFeatureShowcase;
